import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

type AuthDividerProps = {
  label?: string;
};

export function AuthDivider({ label }: AuthDividerProps) {
  const { i18n } = useLingui();

  return (
    <div className="relative flex items-center gap-3 text-sm">
      <span className="border-border flex-1 border-t" />
      <span className="text-muted-foreground shrink-0">{label ?? i18n._(msg`Or`)}</span>
      <span className="border-border flex-1 border-t" />
    </div>
  );
}
